import { render, staticRenderFns } from "./TranscriptionHead.vue?vue&type=template&id=3076e348&scoped=true&"
import script from "./TranscriptionHead.vue?vue&type=script&lang=js&"
export * from "./TranscriptionHead.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionHead.vue?vue&type=style&index=0&id=3076e348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076e348",
  null
  
)

export default component.exports